<template>
  <ancestryline-modal title="protocol.tab-general.actions.print-contracts"  id="protocol-printcontract-modal" :close="true" @close="close" :loading="false">

    <card>
      <template v-for="(protocolClient, index) in totalPricePerClientDTO">
        <div class="p-d-flex p-col-12 line-content line-of-client p-mb-2" :key="index">
          <div class="text-vertical-center p-col-7">
            {{protocolClient.client.name}}
          </div>
          <coff-input-select v-model="protocolClient.installments" label="protocol.tab-general.actions.installments" class="text-vertical-center p-col-3" :options="installments" option-value="id"/>
          <div class="text-vertical-center p-col-2" style="min-width: fit-content;">
            {{$n(protocolClient.value, 'currency')}}
            <a class="text-vertical-center cursor-pointer p-ml-3" @click.prevent="attach(protocolClient, index)">
              <i class="fa fa-link" :title="$t('forms.contract.modal.add-dependent')"/>
            </a>
          </div>
        </div>
        <div class="p-d-flex p-col-11 line-content p-ml-auto p-mb-2" v-for="(subClientPrice, index) in protocolClient.attach" :key="'dependent'+index">
          <div class="p-col-10 p-mr-auto">
            {{subClientPrice.client.name}}
          </div>
          <div class="p-col-2 p-mr-auto">
            {{$n(subClientPrice.value, 'currency')}}
          </div>
        </div>
        <div class="p-d-flex p-col-2 line-content p-ml-auto p-mb-2" style="min-width: fit-content;" v-if="protocolClient.attach && protocolClient.attach.length > 0" :key="'total'+index">
          {{$t('forms.contract.modal.total')+': '+$n(protocolClient.total, 'currency')}}
        </div>
        <template v-if="protocolClient.discount > 0">
          <div  class="p-d-flex p-col-11 p-ml-auto" style="margin-top: -16px;" :key="'total-discount_break_line'+index"></div>
          <div  class="p-d-flex p-col-2 line-content p-ml-auto p-mb-2" style="min-width: fit-content;" :key="'total-discount'+index">
            {{$t('forms.contract.modal.total-with-discount')+': '+ $n(protocolClient.total - protocolClient.discount, 'currency') }}
          </div>
        </template>
      </template>
      <div class="p-col-12 line-content line-of-client p-mb-2 text-center" v-if="totalPricePerClientDTO.length === 0">
        {{$t('protocol.tab-services.no-client')}}
      </div>
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <div class="p-ml-auto">
        <Button :label="$t('protocol.tab-general.actions.print-contracts')" @click="printContracts" class="p-ml-2"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";
import ProtocolBusiness from "@/business/ProtocolBusiness";
import ModalPrintContractAttach from "@/viewer/protocol/ModalPrintContractAttach";
import ArrayUtils from "@/utils/ArrayUtils";

export default {
  name: "ModalPrintContract",

  props: {
    protocol: {type: Object, default: () => {return {}}},
  },

  async mounted() {
    await this.getTotalPricePerPerson();
  },

  data(){
    return {
      totalPricePerClientDTO: [],
      installments: [
        {id: 1, name: "1 "+ this.$t('protocol.tab-general.actions.installment')},
        {id: 2, name: "2 "+ this.$t('protocol.tab-general.actions.installments')},
        {id: 3, name: "3 "+ this.$t('protocol.tab-general.actions.installments')},
      ],
    }
  },

  methods:{

    close(){
      DialogService.closeModal();
    },

    printContracts(){
      DialogService.closeModal(this.totalPricePerClientDTO);
    },

    async getTotalPricePerPerson(){
      const totalPricePerClientDTO = await ProtocolBusiness.getTotalPricePerPerson(this.protocol.id);
      this.totalPricePerClientDTO.push(...totalPricePerClientDTO);
      this.totalPricePerClientDTO.forEach(item => this.calcTotal(item));
    },

    async attach(mainClient, index){
      const possiblesMainClients = this.totalPricePerClientDTO.filter(c => (c.client.id !== mainClient.client.id && ArrayUtils.isEmpty(c.attach)));
      const selectedDependent = await DialogService.openModal(ModalPrintContractAttach, {clientsPriceDTO: possiblesMainClients});
      if(selectedDependent) {
        this.totalPricePerClientDTO[index].attach = this.totalPricePerClientDTO[index].attach ? this.totalPricePerClientDTO[index].attach : [];
        this.totalPricePerClientDTO[index].attach.push(selectedDependent);
        this.addDependentTotal(mainClient, selectedDependent);
        this.$set(this, 'totalPricePerClientDTO', this.totalPricePerClientDTO);
        this.totalPricePerClientDTO = this.totalPricePerClientDTO.filter(item => item.client.id !== selectedDependent.client.id);
      }
    },

    addDependentTotal(mainClient, selectedDependent){
      mainClient.total += selectedDependent.value;
    },

    calcTotal(protocolClient){
      protocolClient.total = protocolClient.value;
      protocolClient.attach.forEach(item => {
        protocolClient.total += item.value;
      });
    }

  }
}
</script>